export default "__VITE_ASSET__b040f506__"